export const AppRoute = {
  NEWS: "news",
  STORE: "store",
  PRICE: "prece",
  CONTACTS: "contacts",
};

export const AppRouteTranslation = {
  NEWS: "новости",
  STORE: "магазин",
  PRICE: "прайс-лист",
  CONTACTS: "контакты",
  SHAVING: "бритвенные принадлежности",
  HAIRCARE: "средства для ухода",
  ACCESSORIES: "аксессуары",
};
